import React, { lazy } from 'react';
import { Route, useRouteMatch, Switch } from 'react-router-dom';

const pagosRegistradosView = lazy(() => import('../../container/finanzas/pagosRegistrados/Index'));
const pagosRegistradosForm = lazy(() => import('../../container/finanzas/pagosRegistrados/Form'));

const pagosRegistradosRoute = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
             <Route path= {`${path}/finanzas/pagos-registrados/listado`} component = { pagosRegistradosView } />
             <Route path={`${path}/finanzas/pagos-registrados/agregar`} component = { pagosRegistradosForm } />
             <Route exact path = {`${path}/finanzas/pagos-registrados/ver-detalle/:id`} component = { pagosRegistradosForm } />
            </Switch>
  );
};

export default pagosRegistradosRoute;

